// import { act } from "react-dom/test-utils";
import {
  FETCH_CREATE_SHIPPING_PARAMETERS,
  RESET_CREATE_SHIPPING_PARAMETERS,
} from "../../constants/action.constants";

const initialState = {
  sourcesList: [],
  destinationTypeList: [],
  destinationNameList: [],
  orderTypeList: [],
};

const createShippingOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CREATE_SHIPPING_PARAMETERS:
      return {
        sourcesList: action.payload.sources,
        destinationTypeList: action.payload.destination_types,
        destinationNameList: action.payload.destinations,
        orderTypeList: action.payload.order_type,
      };
    case RESET_CREATE_SHIPPING_PARAMETERS:
      return { ...initialState };
    default:
      return state;
  }
};

export default createShippingOrderReducer;
